import Reveal from '@/components/base/Reveal';
import SectionHeading from '@/components/base/SectionHeading';
import { platformResults } from '@/mocks/results';

export default function PlatformResults() {
  return (
    <section className="relative w-full px-5 md:px-10 pb-20 md:pb-28">
      <div className="max-w-6xl mx-auto">
        <SectionHeading
          label="По площадкам"
          title="Результаты на каждой платформе"
          description="Ведём продвижение там, где живёт ваша аудитория. Вот итоги по каждой из площадок, на которых мы работаем."
        />

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {platformResults.map((item, index) => (
            <Reveal key={item.name} delay={index * 60} className="h-full">
              <div className="h-full p-6 rounded-lg bg-background-100/70 border border-background-200/70 hover:border-primary-400/60 transition-colors">
                <div className="flex items-center justify-between gap-3">
                  <span className="w-12 h-12 flex items-center justify-center rounded-md bg-background-50 border border-background-200/70">
                    <i className={`${item.icon} text-2xl`} style={{ color: item.color }} aria-hidden="true"></i>
                  </span>
                  <span className="px-3 py-1 rounded-full bg-accent-100 text-accent-900 text-xs font-semibold whitespace-nowrap">
                    {item.growth}
                  </span>
                </div>
                <h3 className="mt-5 font-heading text-base text-foreground-950">{item.name}</h3>
                <div className="mt-3 font-heading font-bold text-2xl text-foreground-950">{item.value}</div>
                <p className="mt-1 text-sm text-foreground-600">{item.label}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}